import React from 'react';
import OpeningCard from './opening-card';

const CurrentOpening = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container mx-auto lg:container">
                <div className="grid row lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <h2 className="text-primary mb-2.5" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Current Openings
                        </h2>
                        <p className="mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            We&apos;re looking for people to join the team who are as excited as we are to help build the platform
                            that empowers the future generation of creators to be successful online.
                        </p>
                    </div>
                </div>
                <div className="grid mx-auto xl:grid-cols-1 lg:grid-cols-1 md:grid-cols-1 lg:w-2/4">
                    <OpeningCard position="Senior BDM" exp="4+ Years" location="Ahmedabad" />
                </div>
            </div>
        </div>
    );
};

export default CurrentOpening;
